import React from 'react';
import { useUserContext } from '../context/user';
import { UserInfo } from '../models/IUserDetails';
import { AppHeader } from '@nike/eds';
import { LanguageMenu } from './LanguageMenu';
import { Profile } from './profile';
import { CommandBar } from './command-bar/command-bar';
import { Footer } from './footer/footer';
import { useLocation } from 'react-router-dom';
import { usePassPolicies } from 'context/PassPolicy';
import logo from 'assets/img/passplay_logo.png';

export const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const userInfo: UserInfo = useUserContext();
  const location = useLocation();
  const passPoliciesContext = usePassPolicies();
  const isAuthenticated = !!userInfo?.passplayUser && location.pathname !== '/login';

  return (
    !!passPoliciesContext && (
      <>
        <AppHeader
          className="app-header"
          isDark
          appName=""
          logoSlot={<LanguageMenu />}
          avatarSlot={<Profile userInfo={isAuthenticated ? userInfo : undefined} />}
          commandBarSlot={
            isAuthenticated && passPoliciesContext.passPolicies.length > 0 ? (
              <CommandBar />
            ) : (
              <>
                <div className={`eds-flex eds-flex--justify-content-space-between`}>
                  <div>
                    <img alt="Passplay logo" src={logo} title="passplay logo"></img>
                  </div>
                  <div className={`eds-flex eds-flex--flex-direction-row`}></div>
                </div>
              </>
            )
          }
        />
        <div className="header-break"></div>
        <div className="eds-spacing--mb-40 main-content-div">{children}</div>
        {isAuthenticated ? <Footer /> : undefined}
      </>
    )
  );
};
